import React, { Component } from 'react'

import { Result, Button } from 'antd';

class PageNotFound extends Component {

    _handleClickBackHome = () => {
        this.props.history.push('/app/dashboard');
    }

    render() {
        return (
            <Result
                status="403"
                title="Lỗi truy cập"
                subTitle="Bạn không có quyền truy nhập trang này"
                extra={<Button type="primary" onClick={() =>  this._handleClickBackHome()}>Quay về trang chủ</Button>}
            />
        )
    }
}

export default PageNotFound